import {QueryClient} from '@tanstack/react-query'
import axios from 'axios'

function deveRepetirConsulta(contadorFalhas: number, error: Error): boolean {
  if (contadorFalhas >= 1) return false
  if (!axios.isAxiosError(error) || !error.response) return true

  const status = error.response.status
  return status >= 500
}

export function criarQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: deveRepetirConsulta,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
      },
      mutations: {
        retry: false,
      },
    },
  })
}
